"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'デジロト',
    organizationId: '7kLqELsT4VS5iHwv7ZIW',
    applicationKey: 'digilot',
    applicationType: 'organization',
    artistId: undefined,
    deeplinkUrl: 'https://digilot.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/3161857',
    deeplinkProd: 'digilot.utoniq.com',
    custom: {
        modules: {
            tutorial: true,
            trade: true,
            membership: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            nft: true,
            item: true,
            store: true,
            campaign: true,
            mission: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: ['home', 'myCollections', 'campaign-events', 'artist'],
        artistTabs: ['home', 'collections', 'gachas', 'trade', 'threads'],
    },
});
